import React from 'react';

import { feedbackMessages } from '../../../../translates/feedbackMessages';
import { generalMessages } from '../../../../translates/generalMessages';
import { ToggleLeftSideMenuAction } from '../../../actions/menuActions';
import { useIntlReexport } from '../../../hooks/useIntlReexport';
import { FeedbackModalProps } from '../../FeedbackModal/FeedbackModal';
import { AlignType, OptionsMenu, useClickOut } from '@ael/shared-components-library';
import { regular } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';

import './Footer.scss';

interface FooterProps {
  watermarkText: string | null;
  renderFeedbackModal?: (onClose: () => void) => React.ReactElement<FeedbackModalProps>;
}

export const Footer: React.FC<FooterProps> = ({ watermarkText, renderFeedbackModal }) => {
  const dispatch = useDispatch();
  const { formatMessage } = useIntlReexport();

  const wrapperRef = React.useRef<HTMLDivElement>(null);
  const { isOpen: isContextMenuOpen, setIsOpen: setIsContextMenuOpen } = useClickOut(false, wrapperRef);

  const [isFeedbackModalShown, setIsFeedbackModalShown] = React.useState(false);

  const toggleIsContextMenuOpen = React.useCallback(() => {
    setIsContextMenuOpen((oldIsOpen) => !oldIsOpen);
  }, [setIsContextMenuOpen]);

  const closeFeedbackModal = React.useCallback(() => setIsFeedbackModalShown(false), []);

  const openFeedbackModal = React.useCallback(() => {
    dispatch(ToggleLeftSideMenuAction);
    setIsContextMenuOpen(false);
    setIsFeedbackModalShown(true);
  }, [dispatch, setIsContextMenuOpen]);

  return (
    <div className="footer__wrapper">
      <span className="footer__watermark-text">
        {watermarkText ? watermarkText : formatMessage(generalMessages.poweredBy)}
      </span>
      <div className="footer__context-menu-wrapper" ref={wrapperRef}>
        <div className="footer__context-menu-positioner">
          {isContextMenuOpen && (
            <OptionsMenu onClose={toggleIsContextMenuOpen} align={AlignType.BottomRight}>
              {renderFeedbackModal && (
                <>
                  <OptionsMenu.OptionsMenuItem onClick={openFeedbackModal} largeFontSize>
                    {formatMessage(feedbackMessages.buttonLabel)}
                  </OptionsMenu.OptionsMenuItem>
                  <OptionsMenu.OptionsMenuDivider />
                </>
              )}
              <OptionsMenu.OptionsMenuItem
                onClick={() => window.open(formatMessage(generalMessages.platformMarketingUrl), '_blank')}
                largeFontSize
              >
                <FormattedMessage {...generalMessages.about} /> <FormattedMessage {...generalMessages.platformName} />
              </OptionsMenu.OptionsMenuItem>
            </OptionsMenu>
          )}
        </div>
        <FontAwesomeIcon
          icon={regular('question-circle')}
          onClick={(e) => {
            e.stopPropagation();
            toggleIsContextMenuOpen();
          }}
          size="lg"
          className="footer__context-menu-icon"
        />
      </div>
      {isFeedbackModalShown && renderFeedbackModal && renderFeedbackModal(closeFeedbackModal)}
    </div>
  );
};
